import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import CloseIcon from 'components/icons/close';

import { toggleFavorite, toggleSaved } from 'redux/reducers/photos';
import { setSidebar } from 'redux/reducers/app';

import { getFavorites, getFilteredForPage, getSaved } from 'redux/selectors/photos';
import { getActiveSpreadId } from 'redux/selectors/app';
import { getSpreadInfo } from 'redux/selectors/books';
import { getChildBirthday } from 'redux/selectors/orders';

import { AssignmentInstructions, AssignmentPhoto, Bricks, Button, Notifications } from 'components';

import styles from './styles.scss';

const DEFAULT_FILTER = 'all';
const FILTERS = [
  {
    id: 'all',
    label: kroostApp.strings.cameraRollTab,
    message: (photos, uploadButton) =>
      photos.count() === 0 ? (
        <span className={styles.noPhotos}>
          <div>{uploadButton}</div>
        </span>
      ) : null,
  },
  {
    id: 'saved',
    label: kroostApp.strings.pinupTab,
    message: photos => (photos.count() === 0 ? kroostApp.strings.savedPhotosInformation : null),
  },
];

const allForPage = getFilteredForPage('all');

@connect(
  state => ({
    appWidth: state.getIn(['app', 'dimensions', 'width']),
    all: allForPage(state),
    favorites: getFavorites(state),
    saved: getSaved(state),
    currentSpread: getActiveSpreadId(state),
    spreadInfo: getSpreadInfo(state),
    childBirthday: getChildBirthday(state),
  }),
  {
    setSidebar,
    toggleSaved,
    toggleFavorite,
  }
)
export default class Assignment extends React.PureComponent {
  static contextTypes = {
    selectFiles: PropTypes.func,
    bookId: PropTypes.number,
    orderId: PropTypes.string,
  };

  componentDidMount() {
    this.props.setSidebar('photos');
  }

  render() {
    const {
      currentSpread,
      spreadInfo,
      match: {
        params: { filter = DEFAULT_FILTER },
      },
      childBirthday,
      toggleSaved,
      toggleFavorite,
      appWidth,
      all: allPhotos,
      favorites,
      saved,
    } = this.props;
    const { bookId, orderId } = this.context;
    const isMonthSpread = spreadInfo.get('isMonthSpread', false);

    const photos =
      filter === 'saved' ? allPhotos.filter(photo => saved.indexOf(photo.get('simpleId')) > -1) : allPhotos;

    const uploadButton = (
      <Button className={styles.selectFilesButton} cta={true} onClick={this.context.selectFiles}>
        {kroostApp.strings.assignmentSelectPhotos}
      </Button>
    );
    const message = FILTERS.find(f => f.id === filter).message(photos, uploadButton);

    const assignmentPhotos = photos
      ? photos
          .map(photo => (
            <AssignmentPhoto
              key={photo.get('simpleId')}
              currentSpread={currentSpread}
              photo={photo}
              isFavorite={favorites.indexOf(photo.get('simpleId')) > -1}
              isSaved={filter === 'saved' || saved.indexOf(photo.get('simpleId')) > -1}
              childBirthday={childBirthday}
              isMonthSpread={isMonthSpread}
              orderId={orderId}
              toggleSaved={toggleSaved}
              toggleFavorite={toggleFavorite}
              className={styles.photo}
            />
          ))
          .toArray()
      : [];

    return (
      <div className={styles.assignment}>
        <Button to={`/${bookId}/${orderId}`} className={styles.close} fillClass={styles.buttonFill}>
          <CloseIcon />
          <div>{kroostApp.strings.assignmentClose}</div>
        </Button>

        <div className={styles.sidebar}>
          <AssignmentInstructions className={styles.instructions} closed={false} />
          <Notifications />
        </div>

        <div className={styles.picker}>
          <div className={styles.header}>
            <div className={styles.tabs}>
              {FILTERS.map(f => (
                <NavLink
                  key={f.id}
                  to={`/${bookId}/${orderId}/assignment/${f.id}`}
                  replace={true}
                  className={f.id === filter ? styles.active : null}>
                  {f.label}
                  <span className={styles.count}>{this.props[f.id].count()}</span>
                </NavLink>
              ))}
            </div>
            <div className={styles.upload}>{uploadButton}</div>
          </div>
          {message ? <div className={styles.message}>{message}</div> : null}
          <div className={styles.photos}>
            <Bricks key={appWidth} lazyLoad={true} photos={assignmentPhotos} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/assignment/index.js